enum SignedAuthorizationDocumentType {
    Prescription,
    ConsultationRequest,
    ExamRequest,
    PatientForm
}

export { SignedAuthorizationDocumentType };
